import { sendEvent } from './sendEvent';

export const GetRenewPrescriptionUrl = (from: string = '') => {
  switch (from) {
    case 'MedicineHistory':
      sendEvent('Medicine', 'NewFileButtonMedicineHistory');
      break;
    case 'RenewPrescription':
      sendEvent('Medicine', 'ExpiredMedicineButtons');
      break;
    default:
      sendEvent('Medicine', 'NewMedicine');
      break;
  }

  return '/universalRequest/1/6/94';
};
